// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .tour_detail_status___wrapper{hyphens:manual}.eopoi-widget .tour_detail_status___wrapper p{margin:0;padding:.75em 0 .75em 0}.eopoi-widget .tour_detail_status___wrapper p:nth-child(2n){background-color:#e6eeef}", ""]);
// Exports
module.exports = exports;
